export const $CheckUserModuleName = "checkUser";

export type TCheckUserState = null;
